import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useQuery } from 'react-query';

import { org_chart_path } from '@routes';
import { getRecords } from '@utils/backend-api/universal';

export const ORG_CHARTS_KEY = 'ORG_CHARTS';

dayjs.extend(utc);

interface OrgChart {
  title: string;
  slug: string;
}

export function buildOrgChart(orgChart?: OrgChart) {
  if (!orgChart) return undefined;
  return {
    ...orgChart,
    url: org_chart_path(orgChart.slug),
  };
}

export default function useOrgCharts() {
  const { data } = useQuery(
    ORG_CHARTS_KEY,
    async () =>
      await getRecords({
        model: 'OrgChart',
        attributes: ['slug', 'title'],
        order: { title: 'asc' },
        identifiers: { hideFromLists: false },
        comparisonIdentifiers: {
          publishedAt: { comparison: '<', value: dayjs.utc().format() },
        },
      })
  );

  return {
    orgCharts: data?.result.map((o: OrgChart) => buildOrgChart(o)) || [],
  };
}
